import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { addDisplayName } from "../Infra/display-name";
import { FlexColumn } from "./common.styles";
import { ScreenTitle } from "./DocumentRetrievalRecordsShared.styles";
import { useFormHelper } from "./FormHelper";
import { ContentContainer, LightText, MobileTextField } from "./HXMobilePage.styles";
import { TitleHeaderView } from "./HXMobileTitleHeader";
import { FooterView } from "./PatientConsentManagerShared";
import { ConfirmWithClearButton, PageWithFixedHeaderAndFooterContent } from "./PatientConsentManagerShared.styles";
import { PatientLandingEmailCollectionViewModel } from "./PatientLandingEmailCollectionViewModel";
import { useViewModel } from "./useViewModel";
import { spinner } from "./Spinner";
import { AccountLinkingView } from "./AccountLinkingView";
import { PatientLoginVerifyPhoneView } from "./PatientLoginVerifyPhoneView";
import { PatientLoginSetupCompletionView } from "./PatientLoginSetupCompletionView";
import { verifyErrorView } from "./PatientLandingView";
import { makeCheckLoaded } from "../Infra/RemoteData";
import { PatientLandingViewModel } from "./PatientLandingViewModel";
const checkLoaded = makeCheckLoaded(PatientLandingViewModel, "organization", "pageTitle");
export const PatientLandingEmailCollectionView = observer((props) => {
    const model = useViewModel(PatientLandingEmailCollectionViewModel, props.container);
    const formHelper = useFormHelper(model.formModel);
    const { t } = useTranslation(["patients"]);
    if (!checkLoaded(model)) {
        return spinner();
    }
    if (model.pendingSetupCompletion)
        return setupCompletionView();
    if (model.pendingVerifyPhone && !model.phoneVerified)
        return verifyPhoneView();
    if (model.isAccountLinkingError)
        return accountLinkingView();
    if (model.loginUIState === "verifyingWithClearError" || model.loginUIState === "verifyingWithSocialLoginError") {
        return verifyErrorView(model, t);
    }
    return (_jsxs(FlexColumn, { grow: true, children: [_jsx(PageWithFixedHeaderAndFooterContent, { isHeaderAndFooterFixed: false, children: _jsxs(ContentContainer, { children: [_jsx(TitleHeaderView, { showBottomBorder: false, title: undefined, showLogo: true, padding: "48px 0px 32px 0px" }), _jsxs(FlexColumn, { gap: 16, alignItems: "center", children: [_jsx(ScreenTitle, { children: t("Please enter your email address") }), _jsx(LightText, { center: true, children: t("This helps our team contact you if you experience any issues while accessing your records.") }), _jsx(MobileTextField, { ...formHelper.bindTextField("email"), placeholder: t("Enter your email address") })] })] }) }), _jsx(FooterView, { container: props.container, showLangugePicker: true, useInMemoryLanguageForLanguagePicker: false, buttons: [
                    _jsx(ConfirmWithClearButton, { onClick: () => model.continue(), loading: model.isClearLoggingIn, children: t("Continue with CLEAR") }),
                ] })] }));
    function setupCompletionView() {
        return _jsx(PatientLoginSetupCompletionView, { container: props.container });
    }
    function verifyPhoneView() {
        return _jsx(PatientLoginVerifyPhoneView, { container: props.container });
    }
    function accountLinkingView() {
        return _jsx(AccountLinkingView, { container: props.container, showTitleHeaderView: true });
    }
});
addDisplayName(PatientLandingEmailCollectionView, "PatientLandingEmailCollectionView");
